import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

/**
 * The staff console's own i18n instance, deliberately separate from `web`'s.
 *
 * Same plumbing as CC-14 established for the customer app, and the same rule:
 * every user-facing string goes through `t()` so a second locale is "add a
 * JSON file" rather than a hunt through the source.
 *
 * A *separate* catalogue rather than a shared one, following OD-18's shell
 * decision — the two apps share almost no strings (this one has personas and
 * tenants where the other has jobs and customers), and a shared catalogue
 * would grow entries neither app uses while coupling their release cadence.
 *
 * Guarded by `isInitialized` because both `main.tsx` and `test/setup.ts`
 * import this module for its side effect.
 */
if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init({
    resources: { en: { translation: en } },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React already escapes.
  });
}

export default i18next;
